<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">

          <el-form-item label="云平台" prop="cloud">
            <el-select v-model="initForm.cloud" placeholder="请选择云平台">
              <el-option
                v-for="cloud in clouds"
                :label="cloud"
                :key="cloud"
                :value="cloud"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Ins账号" prop="ins">
            <el-input v-model="initForm.ins" placeholder="请输入Ins账号"></el-input>
          </el-form-item>
          <el-form-item label="社区名称" prop="location">
            <el-input v-model="initForm.location" placeholder="请输入社区名称（如果是单住户设备，请输入设备名称）"></el-input>
          </el-form-item>
          <el-form-item label="设备类型" prop="device_type">
            <el-select v-model="initForm.device_type" placeholder="请选择设备类型">
              <el-option
                v-for="device in deviceTypes"
                :label="device.name"
                :key="device.value"
                :value="device.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="days" label="监控天数">
            <el-input v-model="initForm.days" placeholder="请输入监控天数"></el-input>
          </el-form-item>
          <el-form-item label="是否启用监控" prop="switch">
            <el-select v-model="initForm.switch" placeholder="启用或关闭设备监控">
            <el-option
              v-for="status in taskStatus"
              :label="status"
              :key="status"
              :value="status"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="任务说明" prop="desc">
            <el-input type="textarea" v-model="initForm.desc" placeholder="请输入任务说明"></el-input>
          </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { TaskStatus } from "@/components/Index/data.js";
import { DeviceTypes } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
    clouds: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        cloud: [{required: true, message: "请选择云平台", trigger: "blur"}],
        ins: [{required: true, message: "请输入Ins账号", trigger: "blur"}],
        location: [{required: true, message: "请输入社区名称", trigger: "blur"}],
        device_type: [{required: true, message: "请选择设备类型", trigger: "blur"}],
        days: [{required: true, message: "监控天数", trigger: "blur"}],
        switch: [{required: true, message: "是否启用监控任务", trigger: "blur"}],
        desc: [{required: false, message: "请输入监控任务说明", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      },
      taskStatus: TaskStatus,
      deviceTypes: DeviceTypes,
      DeviceList: []
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";

        let deviceTypeObject = DeviceTypes.find(type => type.name === this.initForm.device_type);
        let deviceTypeValue = deviceTypeObject ? deviceTypeObject.value : null;

        var formData = {
              cloud: this.initForm.cloud,
              ins: this.initForm.ins,
              location: this.initForm.location,
              device_type: deviceTypeValue,
              days: this.initForm.days,
              status: +(this.initForm.switch === '启用'),
              desc: this.initForm.desc
            };

        if (!valid) {alert("请检查输入是否正确！"); return false;};
        // this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "sre-api/deviceoffline/task/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "sre-api/deviceoffline/task/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
